var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36155 14.6109C7.36155 15.536 6.60586 16.2917 5.68078 16.2917C4.7557 16.2917 4 15.536 4 14.6109C4 13.6858 4.7557 12.9301 5.68078 12.9301H7.36155V14.6109Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2085 14.6109C8.2085 13.6858 8.96419 12.9301 9.88927 12.9301C10.8144 12.9301 11.5701 13.6858 11.5701 14.6109V18.8193C11.5701 19.7444 10.8144 20.5001 9.88927 20.5001C8.96419 20.5001 8.2085 19.7444 8.2085 18.8193V14.6109Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88927 7.86155C8.96419 7.86155 8.2085 7.10586 8.2085 6.18078C8.2085 5.2557 8.96419 4.5 9.88927 4.5C10.8144 4.5 11.5701 5.2557 11.5701 6.18078V7.86155H9.88927Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88926 8.70845C10.8143 8.70845 11.57 9.46415 11.57 10.3892C11.57 11.3143 10.8143 12.07 9.88926 12.07H5.68079C4.7557 12.07 4 11.3143 4 10.3892C4 9.46415 4.7557 8.70845 5.68079 8.70845H9.88926Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6385 10.3892C16.6385 9.46415 17.3942 8.70845 18.3193 8.70845C19.2444 8.70845 20.0001 9.46415 20.0001 10.3892C20.0001 11.3143 19.2444 12.07 18.3193 12.07H16.6385V10.3892Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7917 10.3893C15.7917 11.3143 15.036 12.07 14.111 12.07C13.1859 12.07 12.4302 11.3143 12.4302 10.3893V6.18079C12.4302 5.2557 13.1859 4.5 14.111 4.5C15.036 4.5 15.7917 5.2557 15.7917 6.18079V10.3893Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.111 17.1385C15.036 17.1385 15.7917 17.8942 15.7917 18.8193C15.7917 19.7444 15.036 20.5001 14.111 20.5001C13.1859 20.5001 12.4302 19.7444 12.4302 18.8193V17.1385H14.111Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.111 16.2917C13.1859 16.2917 12.4302 15.536 12.4302 14.6109C12.4302 13.6858 13.1859 12.9301 14.111 12.9301H18.3194C19.2445 12.9301 20.0002 13.6858 20.0002 14.6109C20.0002 15.536 19.2445 16.2917 18.3194 16.2917H14.111Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default ForwardRef;